import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { IApproveBankProofRequest, IApproveBankProofResponse } from '../models/bank-proof.model';
import { approveBankProofFailure, approveBankProofRequest, approveBankProofResponse } from '../actions/bank-proofs.actions';
import { IApproveBankProofDocumentRequest, IApproveBankProofDocumentResponse } from '../models/bank-proof-documents.model';
import { approveBankProofDocumentFailure, approveBankProofDocumentRequest, approveBankProofDocumentResponse } from '../actions/bank-proof-documents.actions';
import { ApproveBankProofState } from './approve-bankproof.reducer';

export const approveBankProofDocumentFeatureKey = 'approveBankProofDocument';

export interface ApproveBankProofDocumentState {
  approveBankProofDocumentRequest: IApproveBankProofDocumentRequest;
  approveBankProofDocumentSuccess: IApproveBankProofDocumentResponse;
  approveBankProofDocumentFailure: IGenericError<ErrorResponse>;
}

export const initialState: ApproveBankProofDocumentState = {
  approveBankProofDocumentRequest: undefined,
  approveBankProofDocumentSuccess: undefined,
  approveBankProofDocumentFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(approveBankProofDocumentRequest, (state, action) => ({
    ...state,
    approveBankProofDocumentRequest: action.request
  })),
  on(approveBankProofDocumentResponse, (state, action) => ({
    ...state,
    approveBankProofDocumentSuccess: action.response
  })),
  on(approveBankProofDocumentFailure, (state, action) => ({
    ...state,
    approveBankProofDocumentFailure: action.error
  }))
);

export const getApproveBankProofDocumentRequest = (state: ApproveBankProofDocumentState) => state.approveBankProofDocumentRequest;
export const getApproveBankProofDocumentResponse = (state: ApproveBankProofDocumentState) => state.approveBankProofDocumentSuccess;
export const getApproveBankProofDocumentFailure = (state: ApproveBankProofDocumentState) => state.approveBankProofDocumentFailure;
